export default __webpack_public_path__ + "static/media/user.1ab91f9c.svg";